import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.3.2_@babel+core@7.27.1_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.3.2_@babel+core@7.27.1_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/common/clock.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/page-components/blogs/blog-filter/BlogFilter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/page-components/blogs/blog-hero/BlogHero.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/page-components/blogs/blogs/styles.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/page-components/blogs/tag/styles.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/blogs/styles.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/chevron-left.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/chevron-right.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/all-in-one-solution/analytics.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/all-in-one-solution/apps.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/all-in-one-solution/chat-text.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/all-in-one-solution/chats.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/all-in-one-solution/clock-edit.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/all-in-one-solution/coin-plus.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/all-in-one-solution/document-award.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/all-in-one-solution/flow-3.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/all-in-one-solution/folder-folder.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/all-in-one-solution/money-settings.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/all-in-one-solution/monitor-search.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/all-in-one-solution/nav-icons.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/all-in-one-solution/rocket.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/all-in-one-solution/shield-lock.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/all-in-one-solution/smartphone-charging.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/all-in-one-solution/user-new.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/all-in-one-solution/user-search.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/all-in-one-solution/user.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/global-it/box.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/global-it/browser-side-bar.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/global-it/credit-card-link.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/global-it/flow-3.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/global-it/laptop-cloud.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/global-it/phone-message.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/global-it/shield-lock-2.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/global-it/user-flash-circle.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/hero/beam.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/hero/brighter_ai.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/hero/carousell.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/hero/cybus.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/hero/cycle.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/hero/mindbody.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/hero/multiplier.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/hero/optilyz.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/hero/quincus.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/hero/vytal.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/hero/workato.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/inv-management/access.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/inv-management/it.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/inv-management/mobile.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/inv-management/procurement.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/inv-management/saas.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/Zen CORE.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/Zen EX.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/Zen HR.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/Zen IT.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/zen-admin-offers/apps.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/zen-admin-offers/chat.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/zen-admin-offers/iphone.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/zen-admin-offers/laptopsetting.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/zen-admin-offers/reload.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/zen-admin-offers/shieldlock.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/zen-admin-offers/usersearch.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/zen-admin-offers/warehouse.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/zen-admin-offers/zen-admin-offers.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/zen-admin-offers/zenadmin-offers-m1.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/zen-core-dm-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/zen-core-ed-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/zen-core-pp-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/zen-core-ra-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/zen-core-wa-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/zen-ex-ai-it-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/zen-ex-zen-ai-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/zen-hr-chr-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/zen-hr-ep-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/zen-hr-hrc-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/zen-hr-pms-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/zen-hr-ta-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/zen-it-asm-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/zen-it-dm-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/zen-it-iam-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/zen-it-imgp-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/zen-it-ith-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/zen-payroll-eor-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/zen-payroll-gcm-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/zen-payroll-gp-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/zen-payroll-pp-image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/v1/assets/icons/home-page/zen-payroll-usp-image.webp");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/v1/common-components/icons-marquee/MarqueeWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/v1/common-components/page-layout/PageLayout.tsx");
